import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { IconButton, Tooltip, TableCell } from '@material-ui/core';
import { showMessage } from 'app/store/fuse/messageSlice';
import AlarmOff from '@material-ui/icons/AlarmOff';
import ConfirmDialog from 'modules/ui/component/ConfirmDialog';
import TaskManagerService from 'app/admin/taskManager/service/TaskManagerService';

function TaskManagerClearScheduleButton(props) {
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();

    const handleDelete = () => {
        setLoading(true);
        TaskManagerService.updateSchedule(props.item.id, /*{ day: null, hour: null, minute: null, month: null }*/null)
            .then(resp => {
                setLoading(false);
                if (!resp.successful) {
                    dispatch(showMessage({ message: 'Error while clearing schedule' }));
                } else {
                    dispatch(showMessage({ message: `Schedule successfully cleared` }));
                    dispatch({ type: `${props.config.key}/event/setNeedDataReload` });
                }
            })
            .catch(resp => {
                setLoading(false);
                dispatch(showMessage({ message: 'Error while clearing schedule' }));
                dispatch({ type: `${props.config.key}/event/setNeedDataReload` });
            });
    };

    return (
        <TableCell className='w-auto text-center' padding='none'>

            <Tooltip title='Clear Schedule'>
                <span>
                    <IconButton disabled={!props.item.schedule} onClick={e => { setShowDeleteConfirm(true) }}>
                        <AlarmOff fontSize='small' />
                    </IconButton>
                </span>
            </Tooltip>

            <ConfirmDialog show={showDeleteConfirm} title="Clear" description="Do you want to clear the schedule?" onYes={() => handleDelete()} onClose={() => setShowDeleteConfirm(false)} />

        </TableCell>
    );
}

export default TaskManagerClearScheduleButton;